import React from 'react';
import { Button, CircularProgress, Typography, Box } from '@mui/material';

const SignupSuccess = ({ email, loading, handleResend }) => (
  <div className="signup-success-area">
    <Typography
      variant="body2"
      style={{ marginBottom: 20, color: 'var(--color-text-secondary)', lineHeight: 1.6 }}
    >
      A verification link has been sent to <strong>{email}</strong>. If you don't see it, check
      your spam folder.
    </Typography>

    <div className="email-clients">
      <Button
        variant="outlined"
        color="inherit"
        fullWidth
        startIcon={
          <img
            src="/svgs/googleLogo.svg"
            alt="google"
            style={{ width: 16, height: 16 }}
          />
        }
        onClick={() => window.open('https://mail.google.com/mail/u/0/#inbox', '_blank')}
        style={{ borderRadius: 8, height: 40, textTransform: 'none', justifyContent: 'flex-start' }}
      >
        Open Gmail
      </Button>
      <Button
        variant="outlined"
        color="inherit"
        fullWidth
        startIcon={
          <img
            src="/svgs/microsoftIcon.svg"
            alt="microsoft"
            style={{ width: 16, height: 16 }}
          />
        }
        onClick={() => window.open('https://outlook.office.com/mail/', '_blank')}
        style={{ borderRadius: 8, height: 40, textTransform: 'none', justifyContent: 'flex-start' }}
      >
        Open Outlook
      </Button>
    </div>

    <Box style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 16 }}>
      <Button
        variant="outlined"
        color="inherit"
        onClick={() => (window.location.href = '/')}
        style={{ borderRadius: 8 }}
      >
        Back to sign in
      </Button>
      <Button
        variant="outlined"
        color="inherit"
        onClick={handleResend}
        disabled={loading}
        style={{ borderRadius: 8, position: 'relative' }}
      >
        {loading ? '' : 'Resend email'}
        {loading && <CircularProgress size={20} color="inherit" />}
      </Button>
    </Box>
  </div>
);

export default SignupSuccess;
